import theme from "../../theme";
import { Box, AppBar, Toolbar } from "@mui/material";
import { useAppDispatch } from "../../redux";
import { resetAppState } from "../../AppSlice";
import { resetInfoPageState } from "../InfoPage/InfoPageSlice";
import { resetContactInfoState } from "../CompletionPage/ContactInfoSlice";
import { resetRegistrationPageState } from "../RegistrationPage/RegistrationPageSlice";
import { resetImageCaptureState } from "../ImageCapture/ImageCaptureSlice";

export default function _Header() {
  const dispatch = useAppDispatch();

  const returnToHomePage = () => {
    dispatch(resetAppState());
    dispatch(resetInfoPageState());
    dispatch(resetContactInfoState());
    dispatch(resetRegistrationPageState());
    dispatch(resetImageCaptureState());
  };

  return (
    <Box>
      <AppBar
        sx={{
          zIndex: 1,
          minHeight: "75px",
          direction: "ltr",
          position: "relative",
        }}
      >
        <Toolbar>
          <Box
            component="img"
            src="/images/paneem_cc_logo.svg"
            alt="Logo"
            onClick={returnToHomePage}
            sx={{
              width: "25%",
              [theme.breakpoints.down("sm")]: {
                display: "none",
              },
              [theme.breakpoints.down("xs")]: {
                display: "none",
              },
            }}
          />
        </Toolbar>
      </AppBar>
    </Box>
  );
}
